<template>
  <div class="single-condition flex-1 flex">
    <el-select class="ml-3" v-model="condition" size="small">
      <el-option v-for="item in conditions" :key="item.value" :value="item.value" :label="item.label" />
    </el-select>
    <template v-if="hasInput">
      <el-select collapse-tags clearable v-model="value" size="small" class="ml-3 flex-1" multiple>
        <el-option :value="item" v-for="item in options" :key="item" :label="item"></el-option>
      </el-select>
    </template>
  </div>
</template>

<script>
import { NOT_NULL, NULL, IN, NOT_IN } from '@/assets/js/config/condition-config'

export default {
  name: 'SingleCondition',
  data() {
    return {
      conditions: [
        {
          label: '选中',
          value: IN
        },
        {
          label: '未选中',
          value: NOT_IN
        },
        {
          label: '为空',
          value: NULL
        },
        {
          label: '不为空',
          value: NOT_NULL
        }
      ],
      options: [],
      value: []
    }
  },
  created() {
    this.options = this.data.optionValue
    this.condition = IN
  },
  methods: {
    getParam() {
      if (!this.value.length) {
        throw new Error(`${this.data.optionName}搜索值不能为空`)
      }
      return this.value
    },
    getShowText() {
      let label = this.conditions.find(c => c.value === this.condition).label
      return `${this.data.optionName} ${label}${this.value ? ' ' + this.value.join(',') : ''}`
    }
  }
}
</script>

<style scoped></style>
